import _ from 'lodash';
import Filter from "./Filter";

const StockFilterData = {
	znacka_id: {
		name: 'znacka',
		title: 'Značka',
		getEl: function() {
			return $('#znacka', Filter.form);
		},
		getValue: function() {
			const val = this.getEl().val();
			return val.length === 0 ? null : this.getEl().val();
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		getTitleByValue: function(val) {
			return this.getEl()
				.find('option[value="' + val + '"]')
				.text();
		},
	},
	store_id: {
		name: 'store',
		title: 'Prevádzka',
		getEl: function() {
			return $('#store', Filter.form);
		},
		getValue: function() {
			const val = this.getEl().val();
			return val.length === 0 ? null : this.getEl().val();
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		getTitleByValue: function(val) {
			return this.getEl()
				.find('option[value="' + val + '"]')
				.text();
		},
	},
	model_id: {
		name: 'model',
		title: 'Model',
		getEl: function() {
			return $('#model', Filter.form);
		},
		getValue: function() {
			const val = this.getEl().val();
			return val.length === 0 ? null : this.getEl().val();
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		getTitleByValue: function(val) {
			return this.getEl()
				.find('option[value="' + val + '"]')
				.text();
		},
	},
	farba_id: {
		name: 'farba',
		title: 'Farba',
		getEl: function() {
			return $('#farba', Filter.form);
		},
		getValue: function() {
			return this.getEl().val();
		},
	},
	palivo_id: {
		name: 'palivo',
		title: 'Palivo',
		getEl: function() {
			return $('#palivo', Filter.form);
		},
		getValue: function() {
			const val = this.getEl().val();
			return val.length === 0 ? null : this.getEl().val();
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		getTitleByValue: function(val) {
			return this.getEl()
				.find('option[value="' + val + '"]')
				.text();
		},
	},
	karoseria_id: {
		name: 'karoseria',
		title: 'Karoséria',
		getEl: function() {
			return $('#karoseria', Filter.form);
		},
		getValue: function() {
			const val = this.getEl().val();
			return val.length === 0 ? null : this.getEl().val();
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		getTitleByValue: function(val) {
			return this.getEl()
				.find('option[value="' + val + '"]')
				.text();
		},
	},
	rok_vyroby: {
		name: 'rok_vyroby',
		title: 'Rok výroby',
		getEl: function() {
			return $('#rok_vyroby', Filter.form);
		},
		getValue: function() {
			const val = this.getEl().val();
			return val.length === 0 ? null : this.getEl().val();
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		getTitleByValue: function(val) {
			return this.getEl()
				.find('option[value="' + val + '"]')
				.text();
		},
	},
	cena_od_do: {
		abstract: true,
		name: 'cena_od_do',
		leftSide: null,
		rightSide: null,
		title: 'Cena Od Do',
		init: function() {
			var self = this;
			var el = this.getEl();

			this.leftSide = StockFilterData.cena_od;
			this.rightSide = StockFilterData.cena_do;
			this.minMaxLimit = this.getMinMaxLimit();
			this.minMax = this.getMinMax();

			if (!el.length) return;

			var values = [
				this.leftSide.getValue() || this.min || 0,
				this.rightSide.getValue() || this.max,
			];

			if (values[0] == values[1]) this.minMax = values = [0, 1];

			el.slider({
				range: true,
				min: this.min,
				max: this.max,
				step: 1,
				values: values,
				disabled: (values[0] == 0 && values[1] == 1) || values[0] == values[1],
				create: function(event, ui) {
					$('.ui-slider-handle', event.target).each(function(i, el) {
						if (i == 0) $(this).addClass('handleFrom');
						if (i == 1) $(this).addClass('handleTo');
					});
					$('<div>', {
						class: 'ui-slider-range ui-widget-header ui-corner-all',
						style: 'width: calc(100% + 16px);left: -8px;background: #bbbbbb;',
					}).prependTo($(this));
				},
				change: function(e, ui) {
					var handle = $(ui.handle);
					var isSlideEvent = !!handle && !!e.originalEvent;

					if (!isSlideEvent) return;

					if (handle.hasClass('handleFrom')) self.leftSide.setValue(ui.values[0], true);
					if (handle.hasClass('handleTo')) self.rightSide.setValue(ui.values[1], true);
				},
				slide: function(e, ui) {
					self.setViewValues(ui.values);
				},
				stop: function(e, ui) {
					var handle = $(ui.handle);

					var diff = Math.ceil((self.max - self.min) / 60 / 100) * 100;

					//Ak hybem lavou kluckou
					if (handle.hasClass('handleFrom')) {
						//Ak som uplne vpravo
						if (ui.values[0] == self.max)
							self.setValue([Math.max(self.max - diff, 0), ui.values[1]]);

						//Ak som naposuval rovnake hodnoty
						if (ui.values[0] == ui.values[0])
							self.setValue([Math.max(ui.values[0] - diff, 0), ui.values[1]]);

						//Ak som za limitom
						if (ui.values[0] > self.maxLimit)
							self.setValue([self.maxLimit, ui.values[1]]);
					}

					//Ak hybem pravou kluckou
					if (handle.hasClass('handleTo')) {
						//Ak som uplne vlaco
						if (ui.values[1] == self.min)
							self.setValue([ui.values[0], Math.min(self.min + diff, self.max)]);

						//Ak som naposuval rovnake hodnoty
						if (ui.values[1] == ui.values[0])
							self.setValue([ui.values[0], Math.min(ui.values[1] + diff, self.max)]);

						//Ak som za limitom
						if (ui.values[1] < self.minLimit)
							self.setValue([ui.values[0], self.minLimit]);
					}
				},
			});
		},
		getEl: function() {
			return $('#cena_od_do', Filter.form);
		},
		getValue: function() {
			return [this.leftSide.getValue() || undefined, this.rightSide.getValue() || undefined];
		},
		setValue: function(values) {
			var el = this.getEl();

			el.slider('values', [values[0], values[1]]);
			el.slider(values[0] == values[1] ? 'disable' : 'enable');

			this.setViewValues(values);

			return this;
		},
		setViewValues: function(values) {
			$('#cena_od_view').text(values[0].toLocaleString('sk'));
			$('#cena_do_view').text(values[1].toLocaleString('sk'));
		},
		getMinMax: function() {
			var el = this.getEl();
			return [parseInt(el.attr('min')), parseInt(el.attr('max'))];
		},
		getMinMaxLimit: function() {
			var el = this.getEl();
			return [parseInt(el.attr('min-limit')), parseInt(el.attr('max-limit'))];
		},
		setMinMax: function(val1, val2) {
			var el = this.getEl();
			el.attr('min', val1);
			el.attr('max', val2);
			el.slider('option', 'min', val1);
			el.slider('option', 'max', val2);
			this.minMax = this.getMinMax();
			return this;
		},
		setMinMaxLimit: function(val1, val2) {
			var el = this.getEl();
			el.attr('min-limit', val1);
			el.attr('max-limit', val2);
			this.minMaxLimit = this.getMinMaxLimit();
			return this;
		},
		getRibbon: function() {
			var self = this;
			var el = this.getEl();

			if (!el.length) return null;

			var minMax = this.getMinMax();
			var value = this.getValue();
			var sliderValues = el.slider('values');

			if ((!value[0] && !value[1]) || _.isEqual(value, minMax)) return null;

			return $('<div/>', { class: 'ribbon' })
				.html(
					'Cena: ' + (value[0] || sliderValues[0]) + ' - ' + (value[1] || sliderValues[1])
				)
				.append(
					$('<span/>', { class: 'button icon-close' }).click(function() {
						self.setValue([minMax[0], minMax[1]]);
						self.leftSide.setValue(undefined);
						self.rightSide.setValue(undefined, true);
					})
				);
		},
		beforeSend: function() {
			var value = this.getValue();

			if (value[0] == this.min) this.leftSide.setValue(undefined);
			if (value[1] == this.max) this.rightSide.setValue(undefined);
		},
		get min() {
			return this.minMax[0];
		},
		get max() {
			return this.minMax[1];
		},
		get minLimit() {
			return this.minMaxLimit[0];
		},
		get maxLimit() {
			return this.minMaxLimit[1];
		},
	},
	cena_od: {
		name: 'cena_od',
		title: 'Cena od',
		ignoreRibbon: true,
		getEl: function() {
			return $('#cena_od', Filter.form);
		},
		getValue: function() {
			return parseInt(this.getEl().val()) || 0;
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		assertAddToUrl: function() {
			var val = this.getValue();
			var limit = StockFilterData.cena_od_do.getMinMax()[0];
			return val != limit;
		},
	},
	cena_do: {
		name: 'cena_do',
		title: 'Cena do',
		ignoreRibbon: true,
		getEl: function() {
			return $('#cena_do', Filter.form);
		},
		getValue: function() {
			return parseInt(this.getEl().val()) || 0;
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		assertAddToUrl: function() {
			var val = this.getValue();
			var limit = StockFilterData.cena_od_do.getMinMax()[1];
			return val != limit;
		},
	},
	najazdene_od_do: {
		abstract: true,
		name: 'najazdene_od_do',
		leftSide: undefined,
		rightSide: undefined,
		title: 'KM Od Do',
		init: function() {
			var self = this;
			var el = this.getEl();

			this.leftSide = StockFilterData.najazdene_od;
			this.rightSide = StockFilterData.najazdene_do;
			this.minMaxLimit = this.getMinMaxLimit();
			this.minMax = this.getMinMax();

			if (!el.length) return;

			var values = [
				this.leftSide.getValue() || this.min || 0,
				this.rightSide.getValue() || this.max,
			];

			if (values[0] == values[1]) this.minMax = values = [0, 1];

			el.slider({
				range: true,
				min: this.min,
				max: this.max,
				step: 1,
				values: values,
				disabled: (values[0] == 0 && values[1] == 1) || values[0] == values[1],
				create: function(event, ui) {
					$('.ui-slider-handle', event.target).each(function(i, el) {
						if (i == 0) $(this).addClass('handleFrom');
						if (i == 1) $(this).addClass('handleTo');
					});
					$('<div>', {
						class: 'ui-slider-range ui-widget-header ui-corner-all',
						style: 'width: calc(100% + 16px);left: -8px;background: #bbbbbb;',
					}).prependTo($(this));
				},
				change: function(e, ui) {
					var handle = $(ui.handle);
					var isSlideEvent = !!handle && !!e.originalEvent;

					if (!isSlideEvent) return;

					if (handle.hasClass('handleFrom')) self.leftSide.setValue(ui.values[0], true);
					if (handle.hasClass('handleTo')) self.rightSide.setValue(ui.values[1], true);
				},
				slide: function(e, ui) {
					self.setViewValues(ui.values);
				},
				stop: function(e, ui) {
					var handle = $(ui.handle);

					var diff = Math.ceil((self.max - self.min) / 60 / 100) * 100;

					//Ak hybem lavou kluckou
					if (handle.hasClass('handleFrom')) {
						//Ak som uplne vpravo
						if (ui.values[0] == self.max)
							self.setValue([Math.max(self.max - diff, 0), ui.values[1]]);

						//Ak som naposuval rovnake hodnoty
						if (ui.values[0] == ui.values[0])
							self.setValue([Math.max(ui.values[0] - diff, 0), ui.values[1]]);

						//Ak som za limitom
						if (ui.values[0] > self.maxLimit)
							self.setValue([self.maxLimit, ui.values[1]]);
					}

					//Ak hybem pravou kluckou
					if (handle.hasClass('handleTo')) {
						//Ak som uplne vlaco
						if (ui.values[1] == self.min)
							self.setValue([ui.values[0], Math.min(self.min + diff, self.max)]);

						//Ak som naposuval rovnake hodnoty
						if (ui.values[1] == ui.values[0])
							self.setValue([ui.values[0], Math.min(ui.values[1] + diff, self.max)]);

						//Ak som za limitom
						if (ui.values[1] < self.minLimit)
							self.setValue([ui.values[0], self.minLimit]);
					}
				},
			});
		},
		getEl: function() {
			return $('#najazdene_od_do', Filter.form);
		},
		getValue: function() {
			return [this.leftSide.getValue() || undefined, this.rightSide.getValue() || undefined];
		},
		setValue: function(values) {
			var el = this.getEl();

			el.slider('values', [values[0], values[1]]);
			el.slider(values[0] == values[1] ? 'disable' : 'enable');

			this.setViewValues(values);

			return this;
		},
		setViewValues: function(values) {
			$('#najazdene_od_view').text(values[0].toLocaleString('sk'));
			$('#najazdene_do_view').text(values[1].toLocaleString('sk'));
		},
		getMinMax: function() {
			var el = this.getEl();
			return [parseInt(el.attr('min')), parseInt(el.attr('max'))];
		},
		getMinMaxLimit: function() {
			var el = this.getEl();
			return [parseInt(el.attr('min-limit')), parseInt(el.attr('max-limit'))];
		},
		setMinMax: function(val1, val2) {
			var el = this.getEl();
			el.attr('min', val1);
			el.attr('max', val2);
			el.slider('option', 'min', val1);
			el.slider('option', 'max', val2);
			this.minMax = this.getMinMax();
			return this;
		},
		setMinMaxLimit: function(val1, val2) {
			var el = this.getEl();
			el.attr('min-limit', val1);
			el.attr('max-limit', val2);
			this.minMaxLimit = this.getMinMaxLimit();
			return this;
		},
		getRibbon: function() {
			var self = this;
			var el = this.getEl();

			if (!el.length) return null;

			var minMax = this.getMinMax();
			var value = this.getValue();
			var sliderValues = el.slider('values');

			if ((!value[0] && !value[1]) || _.isEqual(value, minMax)) return null;

			return $('<div/>', { class: 'ribbon' })
				.html(
					'km: ' + (value[0] || sliderValues[0]) + ' - ' + (value[1] || sliderValues[1])
				)
				.append(
					$('<span/>', { class: 'button icon-close' }).click(function() {
						self.setValue([minMax[0], minMax[1]]);
						self.leftSide.setValue(undefined);
						self.rightSide.setValue(undefined, true);
					})
				);
		},
		beforeSend: function() {
			var value = this.getValue();

			if (value[0] == this.min) this.leftSide.setValue(undefined);
			if (value[1] == this.max) this.rightSide.setValue(undefined);
		},
		get min() {
			return this.minMax[0];
		},
		get max() {
			return this.minMax[1];
		},
		get minLimit() {
			return this.minMaxLimit[0];
		},
		get maxLimit() {
			return this.minMaxLimit[1];
		},
	},
	najazdene_od: {
		name: 'najazdene_od',
		title: 'KM od',
		ignoreRibbon: true,
		getEl: function() {
			return $('#najazdene_od', Filter.form);
		},
		getValue: function() {
			return parseInt(this.getEl().val()) || 0;
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		assertAddToUrl: function() {
			var val = this.getValue();
			var limit = StockFilterData.najazdene_od_do.getMinMax()[0];
			return val != limit;
		},
	},
	najazdene_do: {
		name: 'najazdene_do',
		title: 'KM do',
		ignoreRibbon: true,
		getEl: function() {
			return $('#najazdene_do', Filter.form);
		},
		getValue: function() {
			return parseInt(this.getEl().val()) || 0;
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) el.trigger('change');
		},
		assertAddToUrl: function() {
			var val = this.getValue();
			var limit = StockFilterData.najazdene_od_do.getMinMax()[1];
			return val != limit;
		},
	},
	show_home: {
		name: 'show_home',
		title: 'Iba zvýraznené',
		ignoreUrl: true,
		ignoreRibbon: true,
		getEl: function() {
			return $('#show_home', Filter.form);
		},
		getValue: function() {
			return this.getEl().val();
		},
	},
	sort: {
		name: 'sort',
		title: 'Zoradenie',
		ignoreRibbon: true,
		getEl: function() {
			return $('#sort', Filter.form);
		},
		getValue: function() {
			return this.getEl().val();
		},
	},
	sortDir: {
		name: 'sortDir',
		title: 'Smer zoradenia',
		ignoreRibbon: true,
		getEl: function() {
			return $('#sortDir', Filter.form);
		},
		getValue: function() {
			return this.getEl().val();
		},
	},
	vin_full: {
		name: 'vin_full',
		title: 'VIN',
		ignoreUrl: true,
		ignoreRibbon: true,
		getEl: function() {
			return $('input[name="vin_full[]"]', Filter.form);
		},
		getValue: function() {
			var result = [];
			var elems = this.getEl();

			if (elems.length)
				elems.each(function() {
					result.push($(this).val());
				});

			return result;
		},
	},
	category_id: {
		name: 'kategoria',
		title: 'Kategória',
		getEl: function() {
			return $('#category_id', Filter.form);
		},
		getValue: function() {
			return this.getEl().val();
		},
		getValueForUrl: function() {
			return this.getEl()
				.find('option[value="' + this.getValue() + '"]')
				.attr('key');
		},
		setValue: function(val, trigger) {
			var el = this.getEl();
			el.val(val);
			if (trigger) {
				el.trigger('chosen:updated');
				el.trigger('change');
			}
		},
		getTitleByValue: function(val) {
			return this.getEl()
				.find('option[value="' + val + '"]')
				.text();
		},
	},
	sklad_id: {
		name: 'sklad',
		title: 'Vozidlá na sklade',
		ignoreRibbon: false,
		getEl: function() {
			return $('#sklad_id', Filter.form);
		},
		getValue: function() {
			return this.getEl().val();
		},
	},
	mileage_id: {
		name: 'najazd',
		title: 'Nájazd',
		ignoreRibbon: true,
		getEl: function() {
			return $('.column.mileage', Filter.form);
		},
		getValue: function() {
			const array = [];
			this.getEl().find('[type="checkbox"]').each((index, el)=>{
				if($(el).prop('checked')) {
					array.push($(el).val())
				}
			})
			return array.length ? array : null;
		},
	},
	availability_id: {
		name: 'dostupnost',
		title: 'Dostupnosť',
		ignoreRibbon: true,
		getEl: function() {
			return $('.column.availability', Filter.form);
		},
		getValue: function() {
			const array = [];
			this.getEl().find('[type="checkbox"]').each((index, el)=>{
				if($(el).prop('checked')) {
					array.push($(el).val())
				}
			})
			return array.length ? array : null;
		},
	},
};

export default StockFilterData;